module.exports = __webpack_public_path__ + "static/media/focus-style-color.8b082429.png";